import React from 'react'
import moment from 'moment'

import LoadingButton from '../LoadingButton'

const NotificationListItem = ({id, subject, message, user, updated_at, onEdit, canEdit, onDelete, canDelete}) => {
  return (
    <div className="d-flex flex-row">
      <div className="d-flex flex-column card card-body bg-light mb-3" style={{'white-space': 'pre-line', 'flex': 1}}>
        <div className="d-flex flex-row justify-content-between">
        <div className="d-flex flex-column border-bottom pb-2">
          <span className="lead">{subject}</span>
            <small>{user.first_name} {user.last_name}</small>
            <small>{moment(updated_at).format('Do MMM YYYY')}</small>
          </div>
          <div className="d-flex flex-row">
            {canEdit && <LoadingButton
                className="square-btn mr-2"
                icon="edit"
                loading={false}
                size="sm"
                color="warning"
                forceDisabled={false}
                onClick={() => {
                  if(onEdit) onEdit(id)
                }}
            />}
            {canDelete && <LoadingButton
                className="square-btn"
                icon="trash-alt"
                loading={false}
                size="sm"
                color="danger"
                forceDisabled={false}
                onClick={() => {
                  if(onDelete) onDelete(id)
                }}
            />}
          </div>
        </div>
        <span className="pt-3">{message}</span>
      </div>
    </div>
      
  )
}

export default NotificationListItem